import { MasterDialog } from "#common/Dialog/Dialog"
import { CategoryGet, competenceGet } from "#competence/services/Api"
// import { InputSelect } from "#core/inputs/select/InputSelect"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { EVALUATION } from "#job-profile/constants"
import { jobProfileIdCompetencesPost } from "#job-profile/services/api"
import { Box, Button, Divider, Typography } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import { useCallback, useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
import { JobProfileTableCompetencies } from "./JobProfileCompetenciesTable"
import InputSelect from "#core/components/input/select/InputSelect"
// import { JobProfileTableCompetencies } from "../job-profile-table/JobProfileTableCompetencies"

const competenceDefault = {
	name: "",
	competencia: "",
	interview_score: "",
	evaluation_score: "",
}

const validatedData = (competence) => {
	if (!competence.competencia) {
		toast.error("Seleccione una competencia")
		return
	}
	if (!competence.interview_score) {
		toast.error("Escriba una evaluacion de entrevista")
		return
	}
	if (!competence.evaluation_score) {
		toast.error("Escriba una evaluacion de desempeño")
		return
	}
	return true
}

export default function JobProfileCompetencesForm({
	competenceSelected,
	setCompetenceSelected,
	excluded = [],
	autoFetch = true,
}) {
	const [competenceType, setCompetenceType] = useState(null)
	const params = useMemo(() => ({ list: true }), [])

	const { data, loading: loadingCompetence } = useApi(competenceGet, {
		autoFetch,
		params,
	})
	const { data: categories, loading: loadingCategories } = useApi(CategoryGet, {
		autoFetch,
		params,
	})

	const competencias = useMemo(() => data?.data || [], [data])

	const dataFilter = competencias?.filter((item) => {
		return !excluded?.includes(item?.id) && item?.category === competenceType
	})

	const handleChange = (name, value) => {
		setCompetenceSelected({ ...competenceSelected, [name]: value })
	}
	useEffect(() => {
		setCompetenceSelected((data) => {
			const item = competencias.filter((items) => items.id === data.competencia)
			return { ...data, name: item[0]?.name, category_name: item[0]?.category_name }
		})
	}, [competencias, setCompetenceSelected, competenceSelected.competencia])

	return (
		<Grid2 container spacing={2} alignItems="center" width={"100%"}>
			<Grid2 xs={12}>
				<InputSelect
					label={"Categoría"}
					value={competenceType}
					setValue={setCompetenceType}
					options={categories?.data || []}
					optionsId="id"
					optionsLabel="name"
					loading={loadingCategories}
				/>
			</Grid2>
			<Grid2 xs={12}>
				<InputSelect
					label={"Competencia"}
					value={competenceSelected.competencia}
					setValue={(value) => handleChange("competencia", value)}
					options={dataFilter}
					optionsId="id"
					optionsLabel="name"
					loading={loadingCompetence}
				/>
			</Grid2>
			<Grid2 xs={12}>
				<Divider textAlign="left">
					<Typography>Calificación Minima</Typography>
				</Divider>
			</Grid2>
			<Grid2 xs={6}>
				<InputSelect
					label={"Entrevista por competencia"}
					options={EVALUATION}
					optionsId="id"
					optionsLabel="id"
					description="description"
					value={competenceSelected.interview_score}
					setValue={(event) => handleChange("interview_score", event)}
				/>
			</Grid2>
			<Grid2 xs={6}>
				<InputSelect
					label={"Evaluación por desempeño"}
					options={EVALUATION}
					optionsId="id"
					optionsLabel="id"
					description="description"
					value={competenceSelected.evaluation_score}
					setValue={(event) => handleChange("evaluation_score", event)}
				/>
			</Grid2>
			<Grid2 xs={12}>
				{EVALUATION.map((item) => (
					<Typography key={item.id} variant="body2" color="text.secondary">
						({item.id}) <strong>{item.description}</strong>
					</Typography>
				))}
			</Grid2>
		</Grid2>
	)
}

/**
 * @param {Array} value - Valor actual del estado.
 * @param {React.Dispatch<React.SetStateAction<Array>>} setValue - Setter de estado.
 */
export const JobProfileCompetencesFormList = ({ value, setValues }) => {
	const [competence, setCompetence] = useState([])

	const handleSave = () => {
		if (!validatedData(competence)) return
		setValues((old) => [...old, competence])
		setCompetence(competenceDefault)
	}
	const competenceExcluded = value?.map((c) => c.competencia)
	const valuesOrdered = value?.sort((a, b) =>
		a.category_name.localeCompare(b.category_name)
	)
	return (
		<Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"}>
			<JobProfileCompetencesForm
				{...{
					competenceSelected: competence,
					setCompetenceSelected: setCompetence,
					excluded: competenceExcluded,
				}}
			/>
			<Button onClick={handleSave}>Agregar</Button>
			<Divider />
			<JobProfileTableCompetencies
				data={valuesOrdered || []}
				onDelete={(datum) => {
					setValues((old) => {
						return old.filter((item) => item.competencia !== datum.competencia)
					})
				}}
			/>
		</Box>
	)
}

export const JobProfileCompetencesFormDialog = ({
	open,
	setOpen,
	profileId,
	excluded,
	refresh,
}) => {
	const [disabled, setDisabled] = useState(false)
	const [competence, setCompetence] = useState([])

	const success = () => {
		setOpen(false)
		if (typeof refresh === "function") {
			refresh()
		}
		setCompetence(competenceDefault)
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(jobProfileIdCompetencesPost, {
		end,
		success,
	})

	const handlerSave = useCallback(() => {
		if (!validatedData(competence)) return
		setDisabled(true)
		fetch({ id: profileId, data: competence })
	}, [competence, fetch, profileId])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled,
			},
			{
				label: "Agregar",
				onClick: () => {
					handlerSave()
				},
				disabled,
			},
		],
		[disabled, handlerSave, setOpen]
	)

	return (
		<MasterDialog
			{...{
				open,
				setOpen,
				title: "Agregar Competencia",
				maxWidth: "xl",
				buttons,
			}}
		>
			<JobProfileCompetencesForm
				{...{
					competenceSelected: competence,
					setCompetenceSelected: setCompetence,
					excluded,
				}}
			/>
		</MasterDialog>
	)
}
